import { render, staticRenderFns } from "./RecordInfo.html?vue&type=template&id=014b1934&external"
import script from "./RecordInfo.ts?vue&type=script&lang=ts&external"
export * from "./RecordInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./RecordInfo.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports